<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-app dark id="inspire" style="background-image: linear-gradient( 135deg, #3C8CE7 10%, #00EAFF 100%);">

      <v-content>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="3"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="blue darken-2"
                  dark
                  flat
                >
                  <v-toolbar-title>超管登录</v-toolbar-title>


                </v-toolbar>
                <v-card-text>
                  <v-form
                    ref="form"
                  >
                    <v-text-field
                      label="验证码"
                      name="login"
                      v-model="loginRequest.verifyCode"
                      :rules="[v => !!v || '必输的哦~']"
                      prepend-icon="code"
                      type="text"
                    >
                      <template v-slot:append-outer>
                        <v-img @click="refreshVerfyImg" :src="verifyData.verifyImg"></v-img>
                      </template>
                    </v-text-field>

                    <v-text-field
                      id="password"
                      label="通行证"
                      v-model="loginRequest.passWord"
                      :rules="[v => !!v || '必输的哦~']"
                      name="password"
                      prepend-icon="lock"
                      type="password"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn @click="commit" dark color="blue darken-2">提交</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-content>


    <z-notify ref="notify" ></z-notify>

  </v-app>
</template>

<script>
  import {imgVerify, adminLogin} from '@/api/login'

  export default {
    name: "AdminLogin",
    data() {
      return {
        verifyData: {
          verifyImg: '',
          verifyId: '',
          verifyCode: ''
        },
        loginRequest: {
          verifyId: '',
          verifyCode: '',
          passWord: ''
        },

      }
    },
    methods: {
      commit() {
        if (this.$refs.form.validate()) {
          adminLogin(this.loginRequest).then(res => {
            if(res.verifyResult == '1'){
              this.$store.dispatch('logIn',res.token )
              this.$router.push({path: '/admin/user-management'})
            }else if(res.verifyResult == '-1'){
              this.$refs.notify.show("验证码",{timeout:1000})
              this.refreshVerfyImg()
            }else if(res.verifyResult == '0'){
              this.$refs.notify.show("验证码输入错误",{timeout:1000})
              this.refreshVerfyImg()
            }
          }).catch(err => console.error(err))
        }
      },
      refreshVerfyImg() {
        this.loginRequest.verifyCode = ''
        let req = {
          width: 100,
          height: 30
        }
        imgVerify(req).then(res => {
          this.verifyData.verifyImg = 'data:image/gif;base64,' + res.imgData
          this.loginRequest.verifyId = res.verifyId
          this.loginRequest.verifyCode = res.verifyCode
        }).catch(err => console.error(err))
      }
    },
    created() {
      this.refreshVerfyImg()
      this.$vuetify.theme.dark = false

    }
  }
</script>

<style scoped>

</style>